import { makeStyles } from '@material-ui/core/styles';

import { neutral } from 'shared/styles/colors';

export default makeStyles({
  groups: {
    width: '100%',
    paddingTop: 0,
  },
  groupItem: {
    border: `1px solid ${neutral['20']}`,
    '&:hover': {
      backgroundColor: neutral['10'],
    },
  },
  groupItemTextPrimary: {
    fontWeight: 500,
    color: neutral[100],
  },
  groupItemTextSecondary: {
    color: neutral[60],
  },
});
